import Vue from "vue";
import Router from "vue-router";
import Empresas from "@/components/empresas/Empresas.vue";
import Createcompany from "@/components/empresas/Createcompany.vue";
import NotAllowed from "@/components/core/NotAllowed.vue";
import Login from "@/components/core/Login.vue";
import Perfil from "@/components/core/Perfil.vue";
import Landing from "@/components/core/Landing.vue";
import UserMenu from "@/components/users/UserMenu.vue";
import Users from "@/components/users/Users.vue";
import AddUser from "@/components/users/AddUser.vue";
import EditUser from "@/components/users/EditUser.vue";
import GraphicsMenu from "@/components/graficas/GraphicsMenu.vue";
import Graficas from "@/components/graficas/Graficas.vue";
import GraphByCompany from "@/components/graficas/GraphByCompany.vue";
import Guides from "@/components/informes/Guides.vue";
import View from "@/components/informes/View.vue";
import Viewshare from "@/components/informes/Viewshare.vue";
import DataMenu from "@/components/data/DataMenu.vue";
import Listview from "@/components/informes/Listview.vue";
import UploadDataFrs from "@/components/data/UploadDataFrsV2.vue";
import UploadData from "@/components/data/UploadData.vue";
import SelectUpload from "@/components/data/SelectUpload.vue";
import ListData from "@/components/data/ListData.vue";
import ReportsMenu from "@/components/informes/ReportsMenu.vue";
import Creainforme from "@/components/informes/Crea.vue";
import Listplantilla from "@/components/informes/Listplantilla.vue";
import Carpetalist from "@/components/informes/Listinformes1.vue";
import Lideres from "@/components/lideres/Lideres.vue";
import EncuestaLider from "@/components/lideres/EncuestaLider.vue";
import Finencuesta from "@/components/lideres/Finencuesta.vue";
// import Subirlideres from '@/components/lideres/Subirlideres.vue';
import Listfrs from "@/components/frs/Listfrs.vue";
import Vfrs from "@/components/frs/Vfrs.vue";
import Priorization from "@/components/frs/Priorizationfrs.vue";
import Lider from "@/components/lideres/Liderv1.vue";
import ResultLider from "@/components/lideres/ResultLider.vue";
import Evaluado from "@/components/lideres/Evaluado.vue";
import Estadisticos from "@/components/estadisticos/Estadisticos.vue";
import DataEditor from "@/components/data/DataEditor.vue";

import Logout from "@/components/core/Logout.vue";
import Iniciocmt from "@/components/cmt/Inicio.vue";
import Cmtprocesos from "@/components/cmt/Cmtprocesos.vue";
import Cmtconfiguracion from "@/components/cmt/Cmtconfiguracion.vue";
import Editcreateprocesscmt from "@/components/cmt/Editcreaprocess.vue";
import Aspirantscmt from "@/components/cmt/Aspirantscmt.vue";
import Listaspirantescmt from "@/components/cmt/Listaspirantscmt.vue";
import Resultadoaspirante from "@/components/cmt/Resultadoaspirante.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: (to) => {
      return {
        name: "landing",
        meta: {
          isPublic: true,
        },
      };
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: Landing,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/home",
    component: View,
    name: "home",
    menu: {
      section: "Inicio",
      icon: "dashboard",
      title: "Dashboard",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview",
    component: Listview,
    name: "listview",
    menu: {
      section: "Inicio",
      icon: "list",
      title: "Ver Informes",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listview/:id",
    component: View,
    name: "listviewid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/share/:id",
    component: Viewshare,
    name: "shareid",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/sharelider/:relacionid/:liderid/:procesoid",
    component: ResultLider,
    name: "sharelider",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/notAllowed",
    component: NotAllowed,
    name: "notAllowed",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/perfil",
    name: "perfil",
    component: Perfil,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/empresas",
    component: Empresas,
    name: "empresas",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/createcompany",
    component: Createcompany,
    name: "createcompany",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/editcompany/:id",
    component: Createcompany,
    name: "editcompany",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/datamenu",
    component: DataMenu,
    name: "datamenu",
    menu: {
      section: "Admin",
      icon: "list",
      title: "Datos",
      scope: ["admin"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/datamenu/uploaddata",
        component: SelectUpload,
        scope: ["admin"],
        name: "datamenu.uploaddata",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/datamenu/listfrs",
        component: Listfrs,
        name: "datamenu.listfrs",
        scope: ["admin"],
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/datamenu/listdata",
        component: ListData,
        name: "datamenu.listdata",
        scope: ["admin"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/uploaddata/frs",
    component: UploadDataFrs,
    name: "uploaddatafrs",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/uploaddata/otros",
    component: UploadData,
    name: "uploaddataotros",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/listfrs/:id",
    component: Vfrs,
    name: "listviewfrsid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/priorization/:id",
    component: Priorization,
    name: "priorizationfrsid",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/graphicsmenu",
    component: GraphicsMenu,
    name: "graphicsmenu",
    menu: {
      section: "Admin",
      icon: "assessment",
      title: "Gráficas",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/graphicsmenu/graphics",
        component: Graficas,
        scope: ["admin", "cliente"],
        name: "graphicsmenu.graphics",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/graphicsmenu/graphbycompany",
        component: GraphByCompany,
        name: "graphicsmenu.graphbycompany",
        scope: ["admin", "cliente"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/reportsmenu",
    component: ReportsMenu,
    name: "reportsmenu",
    menu: {
      section: "Admin",
      icon: "description",
      title: "Informes",
      scope: ["admin", "cliente"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/reportsmenu/crea",
        component: Creainforme,
        scope: ["admin", "cliente"],
        name: "reportsmenu.crea",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/reportsmenu/carpetaslist",
        component: Carpetalist,
        name: "reportsmenu.carpetaslist",
        scope: ["admin", "cliente"],
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/reportsmenu/plantillalist",
        component: Listplantilla,
        name: "reportsmenu.plantillalist",
        scope: ["admin", "cliente"],
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/reportsmenu/guides",
        component: Guides,
        name: "reportsmenu.guides",
        scope: ["admin"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/plantillalist/:tipo/:id",
    component: Creainforme,
    name: "editinforme",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/carpetaslist/:tipo/:id",
    component: Creainforme,
    name: "editinforme1",
    meta: {
      isAuthenticated: true,
    },
  },
  // {
  //   path: '/lideres',
  //   component: Subirlideres,
  //   menu: {
  //     section: 'Admin',
  //     icon: 'stars',
  //     title: 'Lideres',
  //     scope: ['admin']
  //   },
  //   name: 'lideres',
  //   meta: {
  //     isAuthenticated: true
  //   }
  // },

  {
    path: "/usermenu",
    component: UserMenu,
    name: "usermenu",
    menu: {
      section: "Admin",
      icon: "group",
      title: "Usuarios",
      scope: ["admin"],
    },
    meta: {
      isAuthenticated: true,
    },
    children: [
      {
        path: "/usermenu/adduser",
        component: AddUser,
        scope: ["admin"],
        name: "usermenu.adduser",
        meta: {
          isAuthenticated: true,
        },
      },
      {
        path: "/usermenu/users",
        component: Users,
        name: "usermenu.users",
        scope: ["admin"],
        meta: {
          isAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/users/edit/:id",
    component: EditUser,
    name: "edituser",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      isAuthenticated: true,
    },
  },

  {
    path: "/verlideres/:id",
    name: "verlideres",
    component: Lideres,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/lider",
    component: Lider,
    menu: {
      section: "Liderazgo",
      icon: "stars",
      title: "Líderes PhD",
      scope: ["lider", "ghumana"],
    },
    name: "lider",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/liderl",
    component: Evaluado,
    menu: {
      section: "Liderazgo",
      icon: "stars",
      title: "Resultados",
      scope: ["liderl"],
    },
    name: "liderl",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/encuesta/:id",
    name: "encuestalider",
    component: EncuestaLider,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/encuesta/fin",
    name: "finencuesta",
    component: Finencuesta,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/resultlider/:procesoid/:liderid",
    name: "resultlider",
    component: ResultLider,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/estadisticos/:procesoid",
    name: "estadisticos",
    component: Estadisticos,
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/dataeditor/:id",
    name: "dataeditor",
    component: DataEditor,
    meta: {
      isAuthenticated: true,
    },
  },
  // ******* Aqui estan las rutas del CMT **********
  {
    path: "/cmt",
    component: Iniciocmt,
    menu: {
      section: "CMT",
      icon: "home",
      title: "Inicio",
      scope: ["cmt"],
    },
    name: "iniciocmt",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/cmtprocesos",
    component: Cmtprocesos,
    menu: {
      section: "CMT",
      icon: "format_list_bulleted",
      title: "Procesos",
      scope: ["cmt"],
    },
    name: "cmtprocesos",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/cmtconfiguracion",
    component: Cmtconfiguracion,
    menu: {
      section: "CMT",
      icon: "settings",
      title: "Configuración",
      scope: ["cmt"],
    },
    name: "cmtconfiguracion",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/creaprocesscmt",
    component: Editcreateprocesscmt,
    name: "creaprocesscmt",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/editprocesscmt/:id",
    component: Editcreateprocesscmt,
    name: "editprocesscmt",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/aspirantescmt/:procesoid",
    component: Listaspirantescmt,
    name: "listaspirantescmt",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/resultadoaspirantecmt/:aspiranteid",
    component: Resultadoaspirante,
    name: "resultadoaspirantecmt",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/loginPro",
    name: "aspirantscmt",
    component: Aspirantscmt,
    meta: {
      isPublic: true,
    },
  },

  // ********* Aqui terminan las rutas del CMT ********
  // Default
  {
    path: "*",
    redirect: "/landing",
  },
];

const router = new Router({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  let loggedin = localStorage.getItem("loggedin");
  loggedin = JSON.parse(loggedin);
  if (to.matched.some((record) => record.meta.isAuthenticated)) {
    if (!loggedin) {
      console.log("se va para landing");
      next("landing");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js